module.exports = __webpack_public_path__ + "img/blending-into-left.3fd4f15c.png";